import { ITool } from 'src/app/modules/tools/interfaces/tool.interface';
import { ToolID } from '../enums/tool-id';

export const tools: { [key: string]: ITool } = {
  VIDEO_POPUP: {
    id: ToolID.VIDEO_POPUP,
    toolName: 'Video',
    icon: 'video_icon.svg',
    toggledIcon: 'video_icon.svg',
    testId: 'htc-video-popup-toolbar-button',
  },
  ON_DEMAND_HINT: {
    id: ToolID.ON_DEMAND_HINT,
    toolName: 'Hints',
    icon: 'hint_unread.svg',
    testId: 'htc-on-demand-hint-toolbar-button',
  },
  RUBRIC_POPUP: {
    id: ToolID.RUBRIC_POPUP,
    toolName: 'Rubric',
    icon: 'rubric.svg',
    testId: 'htc-rubric-toolbar-button',
  },
  PREK2_VIDEO_POPUP: {
    id: ToolID.VIDEO_POPUP,
    toolName: '',
    icon: 'prek2_video_icon.svg',
    toggledIcon: 'prek2_video_icon.svg',
    testId: 'htc-video-popup-toolbar-button',
  },
  PREK2_VERBAL_PROMPT: {
    id: ToolID.PREK2_VERBAL_PROMPT,
    toolName: '',
    icon: 'Amira2.svg',
    toggledIcon: 'Amira2.svg',
    testId: 'htc-verbal-prompt-toolbar-button',
    extraIcon: { icon: 'prek2-speaker.svg', toggledIcon: 'prek2-pause.svg' },
    overrideOnClickType: 'VERBAL_PROMPT',
    iconSize: 'large',
    hasPK2Avatar: true,
  },
  VERBAL_ON_DEMAND_PROMPT: {
    id: ToolID.VERBAL_ON_DEMAND_PROMPT,
    toolName: 'Question',
    icon: 'verbal_prompt_icon.svg',
    testId: 'htc-on-demand-verbal-prompt-toolbar-button',
    overrideOnClickType: 'VERBAL_PROMPT',
  },
};
